import { Component } from '@angular/core';
import { MetaService } from '@shared/services/meta/meta.service';
import { SettingsService } from '../../../core/settings/settings.service';

@Component({
  selector: 'app-error404',
  templateUrl: './error404.component.html',
  styleUrls: ['./error404.component.scss']
})
export class Error404Component {

  constructor(
    public settings: SettingsService,
    private metaService: MetaService
  ) {
    this.metaService.setTitleExternalPage('404 error');
  }

}
